
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metadatakvalitet",
      function () {
        return require("private-next-pages/metadatakvalitet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metadatakvalitet"])
      });
    }
  